import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the initial state
interface CheckboxState {
  stations: { [stationTitle: string]: string[] }; // Dynamic station keys
  allSelected: boolean; // Separate property for the flag
}

const initialState: CheckboxState = {
  stations: {}, // Initialize as an empty object for stations
  allSelected: false, // Initial flag value
};

// Create the slice
const checkboxSlice = createSlice({
  name: 'selectedQuestion',
  initialState,
  reducers: {
    toggleStation: (
      state,
      action: PayloadAction<{
        station: string;
        isChecked: boolean;
        questionKeys: string[];
      }>
    ) => {
      const { station, isChecked, questionKeys } = action.payload;
      state.stations[station] = isChecked ? questionKeys : [];
    },
    toggleQuestion: (
      state,
      action: PayloadAction<{
        station: string;
        questionKey: string;
        isChecked: boolean;
      }>
    ) => {
      const { station, questionKey, isChecked } = action.payload;
      if (!state.stations[station]) state.stations[station] = [];
      if (isChecked) {
        state.stations[station].push(questionKey);
      } else {
        state.stations[station] = state.stations[station].filter(
          (key) => key !== questionKey
        );
      }
    },
    toggleAllQuestions: (
      state,
      action: PayloadAction<{
        stations: { title: string; questionKeys: string[] }[];
        isChecked: boolean;
      }>
    ) => {
      const { stations, isChecked } = action.payload;
      for (const { title, questionKeys } of stations) {
        state.stations[title] = isChecked ? questionKeys : [];
      }
      state.allSelected = isChecked; // Update the allSelected flag
    },
    resetState: (state) => {
      Object.assign(state, initialState); // Reset state to initialState
    },
  },
});

export const { toggleStation, toggleQuestion, toggleAllQuestions, resetState } =
  checkboxSlice.actions;
export default checkboxSlice.reducer;
